"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusableStyle = exports.basePositionStyles = exports.UnifiedSkeleton = void 0;
var _mui = require("@ori-ui/mui");
const UnifiedSkeleton = exports.UnifiedSkeleton = (0, _mui.styled)(_mui.Skeleton)({
  transform: 'none'
});
const basePositionStyles = exports.basePositionStyles = {
  bottom: 0,
  left: 0,
  position: 'fixed',
  right: 0,
  top: 0
};
const focusableStyle = theme => ({
  transition: 'background 0.5s ease',
  '&:focus-visible': {
    outline: 'none',
    background: theme.palette.action.focus,
    borderRadius: theme.shape.borderRadius
  }
});
exports.focusableStyle = focusableStyle;